import constants from "./constants";
import createAction from "sagas/createAction";
import { createPromiseAction } from "@adobe/redux-saga-promise";

const actions = {
  showNoAdsToast: (value) => createAction(constants.SHOW_NO_ADS_TOAST, { value }),
  setGoogleUserInfo: (userInfo) => createAction(constants.SET_GOOGLE_USER_INFO, { userInfo }),
  setSyncedOfflineConversions: (synced) => createAction(constants.SET_SYNCED_OFFLINE_CONVERSIONS, { synced }),
  getAccountHierarchy: (token, params) => createAction(constants.GET_ACCOUNT_HIERARCHY, { token, params }),
  getBusinessInfo: (token, params) => createAction(constants.GET_BUSINESS_INFO, { token, params }),
  getGoogleUserInfo: createPromiseAction(constants.GET_GOOGLE_USER_INFO),
  getAccountData: createPromiseAction(constants.GET_ACCOUNT_DATA),
  autoLinkAccount: createPromiseAction(constants.AUTO_LINK_ACCOUNT),
  setBusinessAdwordsId: createPromiseAction(constants.SET_BUSINESS_ADWORDS_ID),
  setBusinessAdwordsName: createPromiseAction(constants.SET_BUSINESS_ADWORDS_NAME),
  setBusinessCanAccess: createPromiseAction(constants.SET_BUSINESS_CAN_ACCESS),
  getAdwordsConversionsData: createPromiseAction(constants.GET_ADWORDS_CONVERSIONS_DATA),
  getAdwordsConversionsLastsend: createPromiseAction(constants.GET_ADWORDS_CONVERSIONS_LASTSEND),
  createOfflineConversion: createPromiseAction(constants.CREATE_OFFLINE_CONVERSION),
  getLinkAccountStatus: createPromiseAction(constants.GET_LINK_ACCOUNT_STATUS),
  getBusinessPipelines: createPromiseAction(constants.GET_BUSINESS_PIPELINES),
  getBusinessSteps: createPromiseAction(constants.GET_BUSINESS_STEPS),
  getAdwordsPipelineConversionsData: createPromiseAction(constants.GET_ADWORDS_PIPELINE_CONVERSIONS_DATA),
  createAdwordsPipelineConversionsData: createPromiseAction(constants.CREATE_ADWORDS_PIPELINE_CONVERSIONS_DATA),
  getOfflineConversionAddon: createPromiseAction(constants.GET_OFFLINE_CONVERSION_ADDON),
  updateOfflineConversionAddon: createPromiseAction(constants.UPDATE_OFFLINE_CONVERSION_ADDON),
  changeSettingPage: (page) => createAction(constants.CHANGE_SETTING_PAGE, { page }),
  getLeadSteps: createPromiseAction(constants.GET_LEAD_STEPS),

  setRwidgetConversionDefaultValue: (params) =>
    createAction(constants.SET_RWIDGET_CONVERSION_DEFAULT_VALUE, {
      params,
    }),

  getGoogleSheetsList: createPromiseAction(constants.GET_GOOGLE_SHEETS_LIST),
  getGoogleExchangeToken: createPromiseAction(constants.GET_GOOGLE_EXCHANGE_TOKEN),
  setGoogleAccount: createPromiseAction(constants.SET_GOOGLE_ACCOUNT),
  getGoogleAccount: createPromiseAction(constants.GET_GOOGLE_ACCOUNT),
  setGoogleSheetsSetting: createPromiseAction(constants.SET_GOOGLE_SHEETS_SETTING),
  getGoogleAdsLeadForm: createPromiseAction(constants.GET_GOOGLE_ADS_LEAD_FORM),
  changeGoogleAdsFormSelectType: (selectType) =>
    createAction(constants.CHANGE_GOOGLE_ADS_FORM_SELECT_TYPE, { selectType }),
  setCheckedGoogleAdsFormItems: (items) => createAction(constants.SET_CHECKED_GOOGLE_ADS_FORM_ITEMS, { items }),
  setGoogleLeadGoogleConnected: (googleConnected) =>
    createAction(constants.SET_GOOGLE_LEAD_GOOGLE_CONNECTED, { googleConnected }),
  setGoogleLeadGoogleDisconnected: (googleDisconnected) =>
    createAction(constants.SET_GOOGLE_LEAD_GOOGLE_DISCONNECTED, { googleDisconnected }),
  changeGoogleLeadSheetsUrlInput: (sheetsUrl) =>
    createAction(constants.CHANGE_GOOGLE_LEAD_SHEETS_URL_INPUT, { sheetsUrl }),
  setGoogleAdsLeadFormSetting: createPromiseAction(constants.SET_GOOGLE_ADS_LEAD_FORM_SETTING),
  setGoogleSheetsGGLeadsSetting: createPromiseAction(constants.SET_GOOGLE_SHEETS_GG_LEADS_SETTING),
  getAllGoogleLeadFormSettings: createPromiseAction(constants.GET_ALL_GOOGLE_LEAD_FORM_SETTINGS),
  switchGoogleLeadFormStatus: createPromiseAction(constants.SWITCH_GOOGLE_LEAD_FORM_STATUS),
  archiveGoogleLeadFormSetting: createPromiseAction(constants.ARCHIVE_GOOGLE_LEAD_FORM_SETTING),
  getGoogleAdsSetting: createPromiseAction(constants.GET_GOOGLE_ADS_SETTING),
  getGoogleSheetsSetting: createPromiseAction(constants.GET_GOOGLE_SHEETS_SETTING),
  getGoogleLeadCRMSetting: createPromiseAction(constants.GET_GOOGLE_LEAD_CRM_SETTING),
  getGoogleLeadFormSetting: createPromiseAction(constants.GET_GOOGLE_LEAD_FORM_SETTING),
  setValidateGoogleLeadForm: (validateForm) => createAction(constants.SET_VALIDATE_GOOGLE_LEAD_FORM, { validateForm }),
  setValidateGoogleSheetsUrl: (validateSheets) =>
    createAction(constants.SET_VALIDATE_GOOGLE_SHEETS_URL, { validateSheets }),
  setValidateGGLeadsGoogleSheetsUrl: (validateSheets) =>
    createAction(constants.SET_VALIDATE_GG_LEADS_GOOGLE_SHEETS_URL, { validateSheets }),
  setDuplicateGoogleForm: (duplicateGGForm) => createAction(constants.SET_DUPLICATE_GOOGLE_FORM, { duplicateGGForm }),
  getGoogleSheetsOfflineConversionsValue: createPromiseAction(constants.GET_GOOGLE_SHEETS_OFFLINE_CONVERSIONS_VALUE),
  setGoogleSheetsOfflineConversionsValue: createPromiseAction(constants.SET_GOOGLE_SHEETS_OFFLINE_CONVERSIONS_VALUE),
  getGoogleSheetsOfflineConversionsLastSent: createPromiseAction(
    constants.GET_GOOGLE_SHEETS_OFFLINE_CONVERSIONS_LAST_SENT,
  ),
  updateGGLeadFormSettingErrorStatus: createPromiseAction(constants.UPDATE_GG_LEAD_FORM_SETTING_ERROR_STATUS),
  setFileInfoError: (fileInfoError) => createAction(constants.SET_FILE_INFO_ERROR, { fileInfoError }),
  setGoogleLoading: (loading) => createAction(constants.SET_GOOGLE_LOADING, { loading }),
  setGoogleSheetsLoading: (loading) => createAction(constants.SET_GOOGLE_SHEETS_LOADING, { loading }),
  setGoogleSheetsError: (error) => createAction(constants.SET_GOOGLE_SHEETS_ERROR, { error }),
  setGoogleAdsLoading: (loading) => createAction(constants.SET_GOOGLE_ADS_LOADING, { loading }),
  setGGConnectionLoading: (loading) => createAction(constants.SET_GG_CONNECTION_LOADING, { loading }),
};

export default actions;
